import { apiPost } from '../../api'
import type { SmallActDue } from '../../api'

interface Props {
  rows: SmallActDue[]
  onChange: () => void
}

export default function SmallActsCard({ rows, onChange }: Props) {
  const markDone = async (id: number) => {
    await apiPost(`/home/small-acts/${id}/done`)
    onChange()
  }

  if (rows.length === 0) {
    return <div className="empty-state">All small acts up to date.</div>
  }

  return (
    <div className="acts-list">
      {rows.map(r => (
        <div key={r.id} className="row">
          <span className="grow">{r.act}</span>
          <span className="mono muted" style={{ flex: '0 0 auto' }}>
            {r.last_done === null
              ? 'never'
              : r.days_overdue === 0
                ? 'due'
                : `${r.days_overdue}d over`}
          </span>
          <button type="button" onClick={() => markDone(r.id)} style={{ minHeight: 32, padding: '0.25rem 0.6rem' }}>done</button>
        </div>
      ))}
    </div>
  )
}
